<template>
<popup title="Patient's Family History" v-if="openPopup" @close="hidePopup()" 
    :displayPopup="openPopup" 
    :show-add-new-btn="true" 
    @on-save-click="handleSavePatientFamilyMembers" 
    @on-cancel-click="handleCancel" 
    @on-add-new-click="handleAddFamilyHistoryMemberClick" >
    <div id="popupContent" style="display:block; min-height: 700px"> 
        <div id="divFamilyHistoryScrollTo">  
            <div id="divFamilyHistoryList" style="max-height: 650px; overflow: auto;">
                <div v-for="member in patientFamilyHistoryMembers"  :key="member">
                    <div v-if="member.Deleted === false" style="border: 6px solid #4372DA; margin: 10px; padding: 10px;">
                        <ul class="ehr-flex-row" style="justify-content: flex-start">
                            <li style="width: 200px; text-align: left;">
                                <label class="ehr-regular-label ehr-white-label">First/Last Name:</label>
                            </li>
                            <li style="width: 250px; text-align: left;">
                                <input type="text" v-model="member.FirstName" @input="onEdit(member)"/>
                                <br />
                                <input type="text" v-model="member.LastName" @input="onEdit(member)" />
                            </li>
                        </ul>
                        <ul class="ehr-flex-row" style="justify-content: flex-start">
                            <li style="width: 200px; text-align: left;">
                                <label class="ehr-regular-label ehr-white-label">Kinship:</label>
                            </li>
                            <li style="width: 250px; text-align: left;">
                                <select v-model="member.KinshipId" style="font-size:14px;" @change="onEdit(member)">
                                    <option value="null">--</option>
                                    <option v-for="option in kinshipList" :value="option.ID" :key="option.ID">
                                        {{ option.DisplayValue }}
                                    </option>
                                </select>
                            </li>
                        </ul>
                        <ul class="ehr-flex-row" style="justify-content: flex-start">
                            <li style="width: 200px; text-align: left;">
                                <label class="ehr-regular-label ehr-white-label">Date of Birth:</label>
                            </li>
                            <li style="width: 250px; text-align: left;">
                                <input  v-mask="'##/##/####'" type="text" v-model="member.DOB" @input="onEdit(member)"/>
                                <!-- <v-date-picker v-model="member.DOB" /> -->
                                <label class="ehr-regular-label ehr-red-label">date format (mm/dd/yyyy)</label>
                            </li>
                        </ul>
                        <ul class="ehr-flex-row" style="justify-content: flex-start">
                            <li style="width: 200px; text-align: left;">
                                <label class="ehr-regular-label ehr-white-label">Smoker?:</label>
                            </li>
                            <li style="width: 250px; text-align: left;">
                                <input type="checkbox" v-model="member.Smoker" @input="onEdit(member)" />
                            </li>
                        </ul>
                        <ul class="ehr-flex-row" style="justify-content: flex-start">
                            <li style="width: 200px; text-align: left;">
                                <label class="ehr-regular-label ehr-white-label">Deceased?:</label>
                            </li>
                            <li style="width: 250px; text-align: left;">
                                <input type="checkbox" v-model="member.Deceased" @input="onEdit(member); onDeceasedClick(member, $event);" />
                            </li>
                        </ul>
                        <ul class="ehr-flex-row" style="justify-content: flex-start" v-show="member.Deceased === true">
                            <li style="width: 200px; text-align: left;">
                                <label class="ehr-regular-label ehr-white-label">If Yes, When?:</label>
                            </li>
                            <li style="width: 250px; text-align: left;">
                                <input v-mask="'##/##/####'" type="text" v-model="member.DateOfDeath" @input="onEdit(member)" /> 
                                <label class="ehr-regular-label ehr-red-label">date format (mm/dd/yyyy)</label>
                            </li>
                        </ul>
                        <ul class="ehr-flex-row" style="justify-content: flex-start" v-show="member.Deceased === true">
                            <li style="width: 200px; text-align: left;">
                                <label class="ehr-regular-label ehr-white-label">Cause of Death:</label>
                            </li>
                            <li style="width: 250px; text-align: left;">
                                <input type="text" v-model="member.CauseOfDeath" @input="onEdit(member)" />
                            </li>
                        </ul>
                        <div style="border: 4px solid #bcd3f1; margin: 10px; padding: 10px;">
                            <ul class="ehr-flex-row" style="justify-content: flex-start">
                                <li style="width: 200px; text-align: left;">
                                    <label class="ehr-regular-label ehr-white-label">Select Health Problem:</label>
                                </li>
                                <li style="width: 250px; text-align: left;">
                                    <select v-model="member.selectedMedicalProblemID" style="font-size:14px;">
                                        <option selected value="null">--</option>
                                        <option v-for="option in medicalProblemList" :value="option.ID" :key="option.ID">
                                            {{ option.DisplayValue }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="ehr-flex-row" style="justify-content: flex-start">
                                <li style="width: 200px; text-align: left;">
                                    <label class="ehr-regular-label ehr-white-label">Age Of Onset:</label>
                                </li>
                                <li style="width: 250px; text-align: left;">
                                    <input type="number" min="0" max="125" @keyup="isInRange(0, 125, $event, member)" v-model="member.selectedAgeOfOnset" />
                                </li>
                                <li style="width: 50px; text-align: left;">
                                    <span @click="handleAddPatientFamilyMedicalProblemClick(member)" title="Add Family Medical Problem" style="padding-top: 0px; cursor:pointer;">
                                        <svg viewBox="0 0 18 18" fill="green" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" width="18px" height="18px">
                                            <g>
                                                <circle fill="green" stroke="none" cx="9" cy="9" r="8.5"></circle>
                                                <line stroke="white" x1="9" y1="4.364" x2="9" y2="13.638"></line>
                                                <line stroke="white" x1="13.637" y1="9" x2="4.365" y2="9"></line>
                                            </g>
                                        </svg>
                                    </span>
                                </li>
                            </ul>
                            <ul class="ehr-flex-row" style="justify-content: flex-start">
                                <li style="width: 200px; text-align: left;">
                                    <label class="ehr-regular-label ehr-white-label">List of Known Problems:</label>
                                </li>
                                <li style="width: 300px; text-align: left;">
                                    <div v-for="problem in member.KnownHealthProblems" :key="problem">
                                        <ul v-if="problem.Deleted === false" class="ehr-flex-row" style="justify-content: flex-start">
                                            <li style="width: 200px; text-align: left;">
                                                <label class="ehr-regular-label ehr-white-label">{{problem.DisplayValue}}</label>
                                            </li>
                                            <li style="width: 50px; text-align: left;">
                                                <label class="ehr-regular-label ehr-white-label">{{problem.AgeOfOnset}}</label>
                                            </li>
                                            <li style="width: 50px; text-align: left;">
                                                <span @click="handleDeletePatientFamilyMedicalProblemClick(problem)" title="Delete Family Medical Problem" style="padding-top: 0px; cursor:pointer;">
                                                    <svg viewBox="0 0 18 18" fill="red" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" width="18px" height="18px">
                                                        <g>
                                                            <circle fill="red" stroke="none" cx="9" cy="9" r="8.5"></circle>
                                                            <line stroke="red" x1="9" y1="4.364" x2="9" y2="13.638"></line>
                                                            <line stroke="white" x1="13.637" y1="9" x2="4.365" y2="9"></line>
                                                        </g>
                                                    </svg>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul class="ehr-flex-row" style="justify-content: flex-start">
                                <li style="width: 50px; text-align: left;">
                                    <span @click="handleDeleteFamilyHistoryMemberClick(member)" title="Delete Family Member" style="padding-top: 0px; cursor:pointer;">
                                        <svg viewBox="0 0 18 18" fill="red" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" width="38px" height="38px">
                                            <g>
                                                <circle fill="red" stroke="none" cx="9" cy="9" r="8.5"></circle>
                                                <line stroke="red" x1="9" y1="4.364" x2="9" y2="13.638"></line>
                                                <line stroke="white" x1="13.637" y1="9" x2="4.365" y2="9"></line>
                                            </g>
                                        </svg>
                                    </span>
                                </li>
                                <li style="width: 250px; text-align: left;">
                                
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</popup>
    
</template>

<script>
    import axios from 'axios';
    //Import jQuery
    // import moment from 'moment';
 
    export default {
    name: "family-history-vue-component",
    props: {
        patientId: String
    },
    data: function () {
        return {
            patientFamilyHistoryMembers: [],
            medicalProblemList: [],
            kinshipList: [],
            changesHaveBeenMade: false,
            openPopup: false
        };
    },
    mounted: function () {
        //mounted is an event in the lifecyle of a vue component
     },
    computed: {
        //no computeds yet
    },
    watch: {
        patientId: function (newVal, oldVal) {
            if (newVal != oldVal) {
                this.reset();
            }
        }
    },
    methods: {
        showPopup(patID) {
            var vm = this;
            vm.patientId= patID;

            vm.openPopup = true;
            vm.reset();
       },
        hidePopup() {
            this.openPopup = false;
        },
        reset() {
            let vm = this;
            vm.changesHaveBeenMade = false;
            vm.handleGetPatientFamilyHistoryMembers();
            vm.handleGetMedicalProblemList();
            vm.handleGetKinshipList();
        },
        getPatientFamilyHistoryMembers() {
            axios.post("../../Common/Services/EmarClientOperations.svc/GetPatientFamilyHistoryMembers", {
                patientId: this.patientId
            })
            .then((response) => {
                this.patientFamilyHistoryMembers = JSON.parse(response.data.d);            
            });
        },
        async getMedicalProblemList() {
            const result = await axios.post("../../Common/Services/EmarClientOperations.svc/GetMedicalProblemList");
            this.medicalProblemList = JSON.parse(result.data.d);
        },
        async getKinshipList() {
            const result = await axios.post("../../Common/Services/EmarClientOperations.svc/GetKinshipList");
            this.kinshipList = JSON.parse(result.data.d);
        },
        savePatientFamilyMembers() {
            let vm = this;

            //date validation
            let hasAnInvalidDate = false;
            let offendingDateValue = '';
            //const minDate = moment("1800-01-01");
            const minDate = new Date(1800, 0, 1)

            for (let i = 0; i < vm.patientFamilyHistoryMembers.length; i++) {
                if (vm.patientFamilyHistoryMembers[i].DOB) {
                    let memberDOB = new Date(vm.patientFamilyHistoryMembers[i].DOB);

                    if (isNaN(memberDOB) || !(memberDOB > minDate)) {
                        hasAnInvalidDate = true;
                        offendingDateValue = "Date of Birth: " + vm.patientFamilyHistoryMembers[i].DOB;
                    }
                }
                if (vm.patientFamilyHistoryMembers[i].DateOfDeath) {
                    let memberDOD = new Date(vm.patientFamilyHistoryMembers[i].DateOfDeath);

                    if (isNaN(memberDOD) || !(memberDOD > minDate)) {
                        hasAnInvalidDate = true;
                        offendingDateValue = "Date of Death: " + vm.patientFamilyHistoryMembers[i].DateOfDeath;
                    }
                }

                if (hasAnInvalidDate === true) {
                    i = vm.patientFamilyHistoryMembers.length;
                }
            }

            if (hasAnInvalidDate === true) {
                vm.$swal("Invalid Date!", offendingDateValue + " Is an invalid date. Please try again.", "error");
            } 
            else {
                axios.post("../../Common/Services/EmarClientOperations.svc/SavePatientFamilyMembers", {
                    patientFamilyHistoryMembers: vm.patientFamilyHistoryMembers,
                    patientId: this.patientId
                }).then(function () {
                    // handle success
                    vm.$swal({
                        title: "Success!", 
                        text: "Family Medical History changes have been saved!", 
                        icon: "success"})
                        .then((result) => {
                            if (result.isConfirmed) {
                                vm.reset();
                            }
                        });
                })
                .catch(function () {
                    // handle error
                    vm.$swal({
                        title: "Error", 
                        text: "An error occurred while saving Family Medical History changes. Please try again.", 
                        icon: "error"});
                });
            }
        },
        handleGetPatientFamilyHistoryMembers: function () {
            let vm = this;
            vm.getPatientFamilyHistoryMembers();
        },
        handleGetMedicalProblemList: function () {
            let vm = this;
            vm.getMedicalProblemList();
        },
        handleGetKinshipList: function () {
            let vm = this;
            vm.getKinshipList();
        },
        handleAddPatientFamilyMedicalProblemClick: function (member) {
            let vm = this;
            //need to find medProblem in vm.medicalProblemList
            //   using member.selectedMedicalProblemID

            // let medProblem = $.grep(vm.medicalProblemList, function (obj) {
            //     return obj.ID == member.selectedMedicalProblemID;
            // });
            let medProblem = this.medicalProblemList.filter(function(elem){
                return elem.ID == member.selectedMedicalProblemID;
            });

            let problem = {
                ID: null,
                DisplayValue: medProblem[0].DisplayValue,
                PatientFamilyHistoryMemberID: member.ID,
                MedicalProblemID: member.selectedMedicalProblemID,
                AgeOfOnset: member.selectedAgeOfOnset,
                Deleted: false
            };

            member.KnownHealthProblems.push(problem);
            member.problemsEdited = true;
            vm.changesHaveBeenMade = true;
        },
        handleDeletePatientFamilyMedicalProblemClick: function (problemToRemove) {
            let vm = this;
            
            // let member = $.grep(vm.patientFamilyHistoryMembers, function (obj) {
            //     return obj.ID == problemToRemove.PatientFamilyHistoryMemberID;
            // });
            let member = this.patientFamilyHistoryMembers.filter(function(elem){
                return elem.ID == problemToRemove.ID;
            });

            let index = member[0].KnownHealthProblems.indexOf(problemToRemove);
            if (index > -1) {
                if (problemToRemove.ID == null) {
                    member[0].KnownHealthProblems.splice(index, 1);
                } else {
                    problemToRemove.Deleted = true;
                    member[0].problemsEdited = true;
                    vm.changesHaveBeenMade = true;
                }
            }
        },
        createNewBlankMember: function () {

            let obj = {
                ID: null,
                FirstName: '',
                LastName: '',
                KinshipId: null,
                DOB: null,
                Smoker: false,
                Deceased: false,
                DateOfDeath: null,
                CauseOfDeath: '',
                KnownHealthProblems: [],
                PatientID: null,
                Sex: '',
                ModifiedBy: null,
                Deleted: false,
                selectedMedicalProblemID: null,
                selectedAgeOfOnset: null,
                memberEdited: false,
                problemsEdited: false,
            };

            return obj;
        },
        handleAddFamilyHistoryMemberClick: function () {
            let vm = this;
            vm.patientFamilyHistoryMembers.unshift(vm.createNewBlankMember());
            vm.handleAddFamilyHistoryMemberScrollToTop();
        },
        handleAddFamilyHistoryMemberScrollToTop: function () {
            let histDiv = document.getElementById('divFamilyHistoryList');
            let scrollToDiv = document.getElementById('divFamilyHistoryScrollTo');
            if (histDiv && scrollToDiv) {
                histDiv.animate({
                    scrollTop: scrollToDiv.offsetTop - 140,
                    scrollLeft: 0
                }, 100);
            }
        },
        handleDeleteFamilyHistoryMemberClick: function (member) {
            let vm = this;

            if (member.ID == null) {
                let index = vm.patientFamilyHistoryMembers.indexOf(member);
                if (index > -1) {
                    vm.patientFamilyHistoryMembers.splice(index, 1);
                }
            } else {
                member.Deleted = true;
                vm.onEdit(member);
            }
        },
        handleSavePatientFamilyMembers: function (callback) {
            let vm = this;
            if (vm.changesHaveBeenMade == true) {
                vm.savePatientFamilyMembers(callback);
            } else {
                vm.$swal({
                    title: "Alert!", 
                    text: "No changes were made. There's nothing to save.", 
                    icon: "success"}
                ).then((result) => {
                    if (result.isConfirmed) {
                        vm.hidePopup();
                    }
                });
                // vm.reset();
                // callback();
            }

        },
        handleCancel: function (callback) {
            let vm = this;

            if (vm.changesHaveBeenMade == true) {
                this.$swal({
                    title: "Unsaved changes",
                    text: "Would you like to save changes?",
                    icon: 'warning',
                    cancelButtonText: "No",
                    showCancelButton: true,
                    confirmButtonText: "Yes"
                }).then((result) => {
                    if (result.isConfirmed) {
                        setTimeout(function () { vm.handleSavePatientFamilyMembers(callback) }, 750);
                    } else {
                        this.hidePopup();
                    }
                });
            } else {
                this.hidePopup();
            }
        },
        onEdit: function (member) {
            let vm = this;
            member.memberEdited = true;
            vm.changesHaveBeenMade = true;
        },
        onDeceasedClick: function (member, event) {
            if (event.currentTarget.checked === false) {
                member.DateOfDeath = null;
                member.CauseOfDeath = '';
            }
        },
        isInRange: function (a, b, event, data) {
            // console.log("event:" + event);
            // console.log("event.key:" + event.key);
            let keyText = event.key.toString();

            //***for firefox
            if (keyText == "Backspace" || keyText == "Delete" || keyText == "ArrowLeft" || keyText == "ArrowRight") {
                return true;
            }
            //**************

            if (keyText != keyText.replace(/[^0-9\\.]/g, '')) {
                this.$swal({
                    title: "Error", 
                     text: "You've entered an invalid value for Age of Onset. Please try again.", 
                    icon: "error"}
                );
                data.selectedAgeOfOnset = "";
                return false;
            }

            //if they've made it this far it's a number from 0-9
            if (event.currentTarget.value < a || event.currentTarget.value > b) {
                this.$swal({
                    title: "Error", 
                    text: "You've entered an invalid value for Age of Onset. Please try again.", 
                    icon: "error"}
                );
                data.selectedAgeOfOnset = "";
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* .sweet-overlay {
        z-index: 99999;
    } */
    
</style>